import { render, staticRenderFns } from "./swpSignature.vue?vue&type=template&id=3b910a64"
import script from "./swpSignature.vue?vue&type=script&lang=js"
export * from "./swpSignature.vue?vue&type=script&lang=js"
import style0 from "./swpSignature.vue?vue&type=style&index=0&id=3b910a64&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b910a64')) {
      api.createRecord('3b910a64', component.options)
    } else {
      api.reload('3b910a64', component.options)
    }
    module.hot.accept("./swpSignature.vue?vue&type=template&id=3b910a64", function () {
      api.rerender('3b910a64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/swpSignature.vue"
export default component.exports